<template>

    <MainContent v-if="homeDesign" paddingClass="flex flex-col items-start gap-4 pt-[1.6rem] pb-[2.4rem] px-[2.4rem]">
      <div
        class="flex items-center justify-center gap-3"
        :class="{ 'cursor-pointer': isProfileNavigable }"
        v-bind="profileLinkAttrs"
        @click="handleProfileNavigate"
        @keydown.enter.prevent="handleProfileNavigate"
        @keydown.space.prevent="handleProfileNavigate"
      >
        <DoctorImage :image="doctor.image" :name="doctor.name" />
        <h4 class="text-black text-[1.6rem]">{{ doctor.name }}</h4>
      </div>
      <p v-if="hasSpecialty" class="text-black font-bold">{{ doctor.specialty }}</p>
      <router-link
        v-if="profileRoute"
        :to="profileRoute"
        class="view_profile text-black text-[1.6rem] underline hover:opacity-60"
      >
        {{ $t('View profile') }}
      </router-link>
    </MainContent>

    <div
      v-else
      class="flex items-center gap-[1.2rem]"
    >
      <div
        :class="{ 'cursor-pointer': isProfileNavigable }"
        v-bind="profileLinkAttrs"
        @click="handleProfileNavigate"
        @keydown.enter.prevent="handleProfileNavigate"
        @keydown.space.prevent="handleProfileNavigate"
      >
        <DoctorImage :image="doctor.image" :name="doctor.name" />
      </div>
      <div class="flex flex-col justify-center items-start gap-[0.8rem]">

        <p
          class="text-[1.7rem] font-semibold text-[#1c1b1a] leading-tight hover:text-[#3346d3] transition-colors"
          :class="{ 'cursor-pointer': isProfileNavigable }"
          v-bind="profileLinkAttrs"
          @click="handleProfileNavigate"
          @keydown.enter.prevent="handleProfileNavigate"
          @keydown.space.prevent="handleProfileNavigate"
        >
          {{ doctor.name }}
        </p>
        <h3 v-if="hasSpecialty" class="text-[1.3rem] font-medium text-[#6b7280]">{{ doctor.specialty }}</h3>
        <!-- , {{ doctor.mainAddress }} -->

        <DoctorRating v-if="showReviews" :reviews="doctor.reviews" />

      </div>
    </div>

</template>

<script>

import MainContent from '@/components/design/mainContent.vue';
import DoctorImage from '@/components/doctor/doctorImage.vue';
import DoctorRating from '@/components/doctor/doctorRating.vue';
import { buildDoctorProfileRoute } from '@/helpers/doctorRouteHelper';

export default {
  name: 'DoctorInformation',
  components: {
    MainContent,
    DoctorImage,
    DoctorRating
  },
  props: {
    doctor: {
      type: Object,
      required: true,
      default: () => ({
        image: '',
        name: '',
        specialty: '',
        location: '',
        rating: 0,
        slug: ''
      })
    },
    homeDesign: {
      type: Boolean,
      default: false
    },
    showReviews: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    hasSpecialty() {
      if (!this.doctor || this.doctor.specialty === null || this.doctor.specialty === undefined) {
        return false;
      }
      return String(this.doctor.specialty).trim().length > 0;
    },
    profileRoute() {
      return buildDoctorProfileRoute(this.doctor);
    },
    isProfileNavigable() {
      return Boolean(this.profileRoute);
    },
    profileLinkAttrs() {
      if (!this.isProfileNavigable) {
        return {};
      }

      return {
        role: 'link',
        tabindex: 0
      };
    }
  },
  methods: {
    handleProfileNavigate() {
      if (!this.isProfileNavigable) {
        return;
      }

      if (this.profileRoute) {
        this.$router.push(this.profileRoute);
      }
    }
  }
}
</script>

<style scoped>
</style>
